import InvitacionMiembroTemplate from "@/components/templates/InvitacionMiembroTemplate";

export default function InvitacionMiembro() {
  return <InvitacionMiembroTemplate />;
}
